import "./VehiclesDetails.scss";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { useEffect } from "react";

import { fetchVehiclesDetails } from "../../../slices/vehiclesDetailsSlice";

import VehiclesDetailsTools from "./components/VehiclesDetailsTools/VehiclesDetailsTools";
import VehiclesDetailsContent from "./components/VehiclesDetailsContent/VehiclesDetailsContent";
import VehicleWarning from "./components/VehicleWarning/VehicleWarning";
import VehiclesActivities from "./components/VehiclesActivities/VehiclesActivities";

const VehiclesDetails = ({ id }) => {
    const dispatch = useDispatch();
    const warning = useSelector((state) => state.vehiclesDetails.warning);
    const token = useSelector((state) => state.auth.token);
    const activities = useSelector((state) => state.vehiclesDetails.activities);

    useEffect(() => {
        dispatch(fetchVehiclesDetails({token, id}))
    }, [dispatch, token, id]);

    return (
        <div className={"vehicles-details"}>
            <div className={"vehicles-details_container"}>
                <div className={"vehicles-details_tools"}>
                    <VehiclesDetailsTools id={id}/>
                </div>
                {warning?.length > 0 && (
                    <div className={"vehicles-details_warning"}>
                        <VehicleWarning id={id}/>
                    </div>
                )}
                <div className={"vehicles-details_content"}>
                    <VehiclesDetailsContent id={id}/>
                </div>
                {activities?.length > 0 && (
                    <div className={"vehicles-details_activities"}>
                        <div className={"vehicles-details_divider"}></div>
                        <VehiclesActivities id={id}/>
                    </div>
                )}
            </div>
        </div>
    )
}

export default VehiclesDetails;